<template>
   <v-window-item>
    <v-card flat :class="useShowMore? 'pr-7 pl-4' : 'pr-7 pl-4 pb-6'" >
    
      <v-card-title class="pb-0">
        <h3 class="text-h3 news-title">
          <slot name="titleText" />
        </h3>
      </v-card-title>
      <v-expand-transition>
      <v-card-text class="pt-1 pb-0 black--text">
        <p class="caption mb-2 font-italic footergrey--text text--darken-1">{{date}}</p>
        <slot name="introText" />
      </v-card-text>
      </v-expand-transition>

      <div v-if="useShowMore">
        <v-card-actions class="pt-1 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            v-if="useShowMore"
            color="link lighten-5 link--text" class="px-4" elevation="0"
            @click="showmorestate = !showmorestate"
          >
          <v-icon class="mr-4" color="link">{{ showmorestate ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            {{ showmorestate ? $t('btntxt.collapse') : $t('btntxt.readon') }}
          </v-btn>
        </v-card-actions>
        <v-divider class="ml-4 mr-2"  v-show="showmorestate" ></v-divider>  
            
        <v-expand-transition>
          <div v-show="showmorestate">
            <v-card-text>
            <slot name="expandedText" />
            </v-card-text>
          </div>
        </v-expand-transition>
      </div>

    </v-card>
  </v-window-item>
</template>
<script>
  export default {
    name: 'NewsSlide',
    props: {
      useShowMore: Boolean, //allow expand or not
      date: String,
    },
    data: () => ({
      showmorestate: false,
    }),
  }
</script>
